module.exports = __webpack_public_path__ + "static/img/land6.749cf85.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/land6.jpg
// module id = pGfy
// module chunks = 0